export default {
  "home": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שלום!✨"])},
    "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["איך אנחנו יכולים לעזור לך היום? אנחנו כאן בשבילך, כך שנתחיל דיאלוג!"])}
  },
  "conversation": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שיחות נוכחיות"])},
    "last_message_empty_caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שיחה חדשה..."])},
    "welcome_text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["שלום! ברוכים הבאים ל- ", _interpolate(_named("messengerName")), "."])},
    "enter_message_info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["נא להזין את השאלה שלך למטה כדי שנוכל לענות לך מהר."])},
    "compose": {
      "input_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["כתוב הודעה..."])}
    },
    "survey": {
      "post": {
        "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["נשמח לשמוע מה אתה חושב על השיחה הזו:"])},
        "thank_you_msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["תודה על המשוב! זה יעזור לנו לשפר את השירות שלנו עבורך ועבור אחרים."])}
      }
    },
    "status": {
      "sending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שולח..."])},
      "sent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["נשלח"])},
      "conversation_is_closed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["השיחה נסגרה"])}
    },
    "errors": {
      "404": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא ניתן לטעון את השיחה!"])}
    }
  },
  "archived_conversations": {
    "header": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["שיחות בארכיון (", _interpolate(_named("count")), ")"])}
  },
  "search": {
    "input_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חפש מאמרי עזרה"])},
    "no_results": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["אין תוצאות עבור \"", _interpolate(_named("query")), "\""])},
    "no_results_hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אנא נסה מילת מפתח אחרת"])}
  },
  "channels": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["איך תרצה ליצור קשר היום?"])},
    "whatsapp": {
      "card_header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שלח הודעה ב-WhatsApp"])},
      "qr_code_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["סרוק עם אפליקציית המצלמה שלך או לחץ על קוד ה-QR כדי להתחיל שיחה."])},
      "button_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פתח את WhatsApp"])},
      "number_undefined_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מספר לא מוגדר."])},
      "initial_text_msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["היי צוות! התעניינתי..."])}
    }
  },
  "agents": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "availability": {
      "online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["צוות התמיכה שלנו זמין"])},
      "offline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
    },
    "status": {
      "online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["זמין"])},
      "offline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא זמין"])},
      "away": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא זמין"])}
    },
    "is_typing": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("agentName")), " מקליד..."])}
  },
  "forms": {
    "fields": {
      "_CONTACT_NAME": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שם"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_CONTACT_EMAIL": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אימייל"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שם", "@", "חברה.com..."])}
      },
      "_CONTACT_PHONE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["טלפון"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(לדוגמה 0612345678)"])}
      },
      "_SUBJECT": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["נושא"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_INITIAL_MESSAGE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שאלה"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_MESSAGE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הודעה"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      }
    },
    "types": {
      "PRE_CHAT": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מלא את הטופס למטה כדי שנוכל להכיר אותך 😄"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שלח את ההודעה שלך"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["נגיע אליך עם אחד מחברי הצוות שלנו!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אופס, לא ניתן להתחיל את השיחה. אתה יכול לנסות שוב?"])}
      },
      "CONTACT_DETAILS": {
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מלא את הטופס למטה כדי שנוכל לשאור איתך קשר"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שלח"])},
        "dismiss-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא עכשיו"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["תודה על המסירת כתובת האימייל שלך."])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אופס, לא ניתן לשלוח את הטופס"])}
      },
      "EMAIL": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שלח לנו הודעה"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מלא את הטופס למטה כדי ליצור קשר עם צוות התמיכה שלנו"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שלח את ההודעה שלך"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הטופס בדואר אלקטרוני נשלח!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אופס, לא ניתן לשלוח את הדואר האלקטרוני. אנא נסה שוב."])}
      },
      "WHATSAPP_CONTACT": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["התחל שיחת WhatsApp"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הצג את עצמך ושאל את שאלתך כדי שנוכל לעזור לך מיד."])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שלח את ההודעה שלך"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הטופס ליצירת קשר ב-WhatsApp נשלח!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אופס, לא ניתן לשלוח את טופס יצירת הקשר ב-WhatsApp. אנא נסה שוב?"])}
      }
    }
  },
  "mailform": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["טופס דואר אלקטרוני"])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מלא את הטופס למטה כדי לפנות לצוות התמיכה שלנו"])},
    "fields": {
      "NAME": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שם"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "SUBJECT": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["נושא"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "QUESTION": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שאלה"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "EMAIL": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אימייל"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "UPLOAD": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "add_btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הוסף קובץ מצורף"])}
      },
      "TOPIC": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["נושא"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["בחר..."])}
      }
    },
    "notifications": {
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הטופס בדואר אלקטרוני נשלח!"])},
      "errors": {
        "default": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לצערנו, לא ניתן לשלוח את הטופס. אנא נסה שוב?"])}
      }
    },
    "submit_btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שלח הודעה"])}
  },
  "common": {
    "buttons": {
      "start_new_conversation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["נפתח דיאלוג חדש"])},
      "show_archived_conversations": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["הצג שיחות בארכיון (", _interpolate(_named("count")), ")"])},
      "go_to_mailform": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שלח דואר אלקטרוני במקום זאת"])},
      "go_back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חזור"])}
    },
    "page_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["💬 הודעה חדשה \"", _interpolate(_named("message")), "\""])},
    "toast": {
      "generic_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אופס, משהו השתבש!"])},
      "message_sent_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אירעה שגיאה בעת שליחת ההודעה"])},
      "giphy_no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא נמצאה תמונת Giphy."])}
    },
    "errors": {
      "upload_too_large": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["גודל הקובץ לא יכול להיות יותר מ-5MB"])},
      "upload_file_type_disallowed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["סוג הקובץ אינו מותר"])}
    }
  },
  "gdpr": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הסכמת עוגיות לפי תקנות GDPR"])},
    "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["היי! נשמח לדבר איתך. אולם, לפי תקנות הכללית של האיחוד האירופי לגבי גניבת נתונים, אנחנו זקוקים להסכמתך תחילה לשימוש במידע אישי (לדוגמה, השם וכתובת האימייל שלך). האם אתה מסכים למטרות הבאות:<br><br>1) נאחסן את המידע האישי שלך כדי שנוכל להמשיך בשיחה בהמשך;<br><br>2) אנחנו יכולים לשלוח לך דואר אלקטרוני למעקב אחרי השיחה שלנו כאן;<br><br>3) אנחנו יכולים לשלוח לך דואר אלקטרוני בנוגע לשירותים ולמבצעים הבאים שלנו.<br>"])},
    "disapprove_body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אין בעיה. אתה יכול לראות את התנאים והמדיניות בכל עת ולהסכים להמשיך"])},
    "yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["כן, אין בעיה"])},
    "no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא, לא היום"])}
  },
  "powered_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מופעל על ידי Grasp"])}
}